/* eslint-disable eqeqeq */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from "react";
import { Button, CircularProgress } from "@material-ui/core";
import axios, { isCancel, CancelToken } from "axios";
import {
  IsEmpty,
  formatBytes,
  formatInternetEstTime,
  getCachedBlobFile,
  setCacheBlobFile,
} from "../../../../utils/helper";

const FileDownloader = (props) => {
  const [progress, setProgress] = useState(0);
  const [isDownloading, setIsDownloading] = useState(false);
  const [cancelTokenSource, setCancelTokenSource] = useState(null);
  const [downloadedContent, setDownloadedContent] = useState(0);
  const [totalContent, setTotalContent] = useState(0);
  const [speed, setSpeed] = useState(0);
  const [estimatedTime, setEstimatedTime] = useState(0);

  const lastTimeRef = useRef(new Date().getTime());
  const lastLoadedRef = useRef(0);
  const lastSpeedRef = useRef(0);

  const downloadFile = async (url) => {
    const source = CancelToken.source();
    setCancelTokenSource(source);
    setIsDownloading(true);
    setProgress(0);
    setDownloadedContent(0);
    setTotalContent(0);
    setSpeed(0);
    setEstimatedTime(0);
    lastLoadedRef.current = 0;
    lastTimeRef.current = new Date().getTime();

    try {
      const getStoredFile = await getCachedBlobFile(props.fileName);
      if (!IsEmpty(getStoredFile) && getStoredFile.code === 1) {
        let csvURL = URL.createObjectURL(getStoredFile.blob);
        let tempLink = document.createElement("a");
        tempLink.href = csvURL;
        tempLink.setAttribute("download", props.fileName);
        tempLink.click();
        setIsDownloading(false);
        return;
      }

      const ckObject = localStorage.getItem("ckAdminUser") || "{}";
      const data = JSON.parse(ckObject) || {};
      const { jwttoken = "" } = data;

      const response = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + jwttoken,
          "Content-Type": "application/json",
        },
        responseType: "blob",
        cancelToken: source.token,
        onDownloadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setProgress(percentCompleted);
          setDownloadedContent(progressEvent.loaded);
          setTotalContent(progressEvent.total);

          // Calculate speed
          const currentTime = new Date().getTime();
          const elapsedTime = (currentTime - lastTimeRef.current) / 1000; // seconds

          if (elapsedTime > 0.5) {
            // Min interval to reduce fluctuations
            const bytesDownloadedInInterval =
              progressEvent.loaded - lastLoadedRef.current;
            const currentSpeed = bytesDownloadedInInterval / elapsedTime;

            // Apply smoothing to reduce speed fluctuations
            const smoothedSpeed = lastSpeedRef.current
              ? lastSpeedRef.current * 0.8 + currentSpeed * 0.2
              : currentSpeed;

            setSpeed(smoothedSpeed);
            lastSpeedRef.current = smoothedSpeed;

            // Estimate remaining time
            const remainingBytes = progressEvent.total - progressEvent.loaded;
            const estimatedTime =
              smoothedSpeed > 0 ? remainingBytes / smoothedSpeed : 0;
            setEstimatedTime(estimatedTime);

            lastTimeRef.current = currentTime;
            lastLoadedRef.current = progressEvent.loaded;
          }
        },
      });

      // Create a blob link to download
      const blob = new Blob([response.data]);
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", props.fileName); // Change the filename as needed
      document.body.appendChild(link);
      link.click();
      link.remove();

      await setCacheBlobFile(blob, props.fileName);
      // Clean up the URL object
      window.URL.revokeObjectURL(downloadUrl);
      // props.downloadImagesData();
      if (props.values.filterStatus == 1) {
        props.onDownloadComplete();
      }
    } catch (error) {
      if (isCancel(error)) {
        console.log("Download canceled");
      } else {
        if (error.response) {
          if (error.response.status === 401) {
            console.error(
              "Unauthorized access - Please check your credentials."
            );
            // Handle unauthorized access (e.g., redirect to login or show a message)
          } else {
            console.error("Download failed:", error.response.data);
          }
        } else {
          console.error("Download failed:", error);
        }
      }
    } finally {
      setIsDownloading(false);
      setProgress(0);
      setCancelTokenSource(null);
      setDownloadedContent(0);
      setTotalContent(0);
      setSpeed(0);
      setEstimatedTime(0);
    }
  };

  const cancelDownload = () => {
    if (cancelTokenSource) {
      cancelTokenSource.cancel();
      setIsDownloading(false);
      setProgress(0);
      setDownloadedContent(0);
      setTotalContent(0);
      setSpeed(0);
      setEstimatedTime(0);
    }
  };

  useEffect(() => {
    cancelDownload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isForceCancel]);

  return (
    <div>
      {!isDownloading && (
        <Button
          onClick={() => downloadFile(props.url || "")}
          disabled={
            isDownloading ||
            props.values.imagesDataLoading ||
            props.values.isDownloadImages ||
            IsEmpty(props.values.selectedSalesData)
          }
          fullWidth
          style={{
            // textDecoration: "underline",
            fontSize: 13,
            padding: 5,
            textTransform: "capitalize",
            cursor: `${props.values.isDownloadImages ? "waiting" : "pointer"}`,
          }}
          color="primary"
        >
          {props.values.isDownloadImages ? (
            <CircularProgress size={16} />
          ) : props.values.filterStatus == 1 ? (
            "Download"
          ) : (
            "Re-Download"
          )}
        </Button>
      )}
      <>
        {isDownloading && (
          <>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  fontSize: 14,
                }}
              >
                Downloading:{" "}
                <b
                  style={{
                    marginLeft: 10,
                  }}
                >
                  {progress}%
                </b>
              </div>
              <progress
                style={{
                  width: "100%",
                }}
                value={progress}
                max="100"
              />
              <div style={{ textAlign: "center", fontSize: 12 }}>
                {`${formatBytes(downloadedContent)} / ${formatBytes(
                  totalContent
                )}`}
              </div>
              <div style={{ textAlign: "center", fontSize: 12 }}>
                Speed: {formatBytes(speed)}/s
              </div>
              <div style={{ textAlign: "center", fontSize: 12 }}>
                Est: {formatInternetEstTime(estimatedTime)}
              </div>
            </div>
            <Button
              onClick={() => cancelDownload()}
              fullWidth
              style={{
                // textDecoration: "underline",
                fontSize: 13,
                padding: 5,
                textTransform: "capitalize",
                textDecoration: "underline",
              }}
              color="primary"
            >
              Cancel
            </Button>
          </>
        )}
      </>
    </div>
  );
};

export default FileDownloader;
